import React from 'react';
import { ContentBox } from 'commonsComponents/contentBox';
import MotoSVG from '../assets/images/lendings-pr-stamo-personal.svg';
import { RoadmapNavigation } from '../../components/steps/roadmapNavigation';
import { connect } from 'react-redux';
import './SuccessLoan.scss';
import { Header } from 'components/header/header';
import CallSVG from 'assets/icons/call-center.svg';
import { deleteCookieAndGoHome, logoutUser } from 'utilities/logoutHelper';
import { formatText } from 'core/i18n';
const translationMainKey = 'successLoan';

const SuccessLoan = ({ userProfile, dispatch }) => {
    const logOut = () => {
        logoutUser(dispatch, userProfile);
        deleteCookieAndGoHome();
    };

    return (
        <React.Fragment>
            <div className="prospects-content">
                <Header showContinueProcess={false} />

                <div className="box-container">
                    <div className="header-container box">
                        <img src={MotoSVG} alt="icon" />
                        <ContentBox
                            title={formatText(`${translationMainKey}-title`, [userProfile.name])}
                            titleSeparator
                            hasShadow={false}
                        >
                            {formatText(`${translationMainKey}-text1_ares`)}
                        </ContentBox>
                    </div>
                    <div className="box">
                        <div className="next-step">
                            <ContentBox
                                title={formatText(`${translationMainKey}-subtitle_ares`)}
                                titleSeparator
                                hasShadow={false}
                                smallTitle
                            >
                                <ul>
                                    <li>{formatText(`${translationMainKey}-bullet1_ares`)}</li>
                                    <li>{formatText(`${translationMainKey}-bullet2_ares`)}</li>
                                </ul>
                            </ContentBox>
                        </div>
                        <div className="call-data">
                            <ContentBox
                                title={formatText(`${translationMainKey}-supportTitle_ares`)}
                                hasShadow={false}
                                leftIcon={{ icon: CallSVG }}
                                smallTitle
                            >
                                {formatText(`${translationMainKey}-supportDescription_ares`)}
                            </ContentBox>
                        </div>
                    </div>
                </div>
                <div className="action-container">
                    <RoadmapNavigation
                        buttonContinueAction={logOut}
                        buttonContinueDisabled={false}
                        buttonPrevHidden={true}
                        buttonCancelHidden={true}
                        buttonContinueText={formatText('button-understood')}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

export default connect(
    state => ({
        userProfile: state.userProfile,
    }),
    dispatch => ({ dispatch })
)(SuccessLoan);
